export default "__VITE_ASSET__10fa14af__"